// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3eeX3","list":"PatternAutocomplete_list__18ZHq"};